import { assert } from '@ember/debug';
import { action } from '@ember/object';
import Component from '@glimmer/component';

interface UiSearchInputSignature {
  Element: HTMLInputElement;
  Args: {
    Named: {
      id?: string;
      value: string;
      onChange: (value: string) => void;
    };
  };
}

export default class UiSearchInputComponent extends Component<UiSearchInputSignature> {
  @action
  onInput(event: Event) {
    const currentTarget = event.currentTarget;

    assert(
      `Expected search input event handler to be used on <input> elements.`,
      currentTarget instanceof HTMLInputElement
    );

    this.args.onChange(currentTarget.value);
  }

  @action
  clear() {
    this.args.onChange('');
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Ui::SearchInput': typeof UiSearchInputComponent;
    'ui/search-input': typeof UiSearchInputComponent;
  }
}
